import { EthersAdapter } from '@reown/appkit-adapter-ethers';
import type { AppKitNetwork } from '@reown/appkit/networks';
import { sepolia } from '@reown/appkit/networks';

// Get projectId from environment variables
export const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID

if (!projectId) {
  throw new Error('VITE_WALLETCONNECT_PROJECT_ID is not defined in .env file')
}

// Create a metadata object  
export const metadata = {
  name: 'Lendefi Markets',
  description: 'Composable lending markets protocol for DeFi',
  url: 'https://lendefimarkets.com', // Always use production URL for consistency
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

// Setup networks (sepolia only - deployed network)
export const networks = [sepolia] as [AppKitNetwork, ...AppKitNetwork[]]

// Export supported chain IDs for validation
export const supportedChainIds = networks.map(network => network.id)

// Create ethers adapter
export const ethersAdapter = new EthersAdapter()